import { SyntheticEvent } from 'react';

import { ConfirmDialog, LinearProgress, Typography } from '@occc-app/design-system';

type DeleteAllowListPhoneNumberConfirmDialogProps = {
  onClose: (event: SyntheticEvent) => void;
  onConfirm: (event: SyntheticEvent) => void;
  loading: boolean;
  entityLabel: string;
};

// TODO: consider extracting universal component from this one
export const DeleteAllowListPhoneNumberConfirmDialog = ({
  onClose,
  onConfirm,
  loading,
  entityLabel,
}: DeleteAllowListPhoneNumberConfirmDialogProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Confirm Deletion'
      onClose={onClose}
      open
      maxWidth='xs'
      confirmButtonText='Delete'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: loading,
        color: 'error',
      }}
    >
      {loading && <LinearProgress />}
      <Typography>{`Are you sure you want to delete ${entityLabel} from the Allow List?`}</Typography>
    </ConfirmDialog>
  );
};
